import { render, staticRenderFns } from "./CardBindDialog.vue?vue&type=template&id=1c6d67a4"
import script from "./CardBindDialog.vue?vue&type=script&lang=js"
export * from "./CardBindDialog.vue?vue&type=script&lang=js"
import style0 from "./CardBindDialog.vue?vue&type=style&index=0&id=1c6d67a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports